module.exports = __webpack_public_path__ + "img/imageAnalysis.819231e7.svg";